import React from "react";
import { Accordion } from "Components/Accordion";
import ADADestinationPhotos from "Components/ADADestinationPhotos";
import ADADestinationVideos from "Components/ADADestinationVideos";
import { createUseStyles } from "react-jss";
import styles from "./styles";

interface Props {
  combinedStops: any[];
}

const ADADestinations = (props: Props) => {
  const { combinedStops } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles();

  if (combinedStops.length === 0) {
    return null;
  }

  return (
    <>
      {combinedStops
        .filter((stop) => !stop.isPointOfInterest)
        .map((stop) => (
          <section key={stop.id} className={classes.destination}>
            <h3 className={classes.destinationHeading}>{stop.title}</h3>
            <p>{stop.fullMapDescription}</p>

            {stop.photos?.length ||
            stop.videos?.length ||
            stop.panoramas?.length ? (
              <Accordion>
                <ADADestinationPhotos
                  id={`${stop.id}-photos`}
                  title="Photos"
                  photos={stop.photos}
                />
                <ADADestinationVideos
                  id={`${stop.id}-videos`}
                  videos={stop.videos}
                />
                <ADADestinationPhotos
                  id={`${stop.id}-panoramas`}
                  title="Panoramas"
                  photos={stop.panoramas}
                />
              </Accordion>
            ) : null}
          </section>
        ))}
    </>
  );
};

export default ADADestinations;
